module.exports = __webpack_public_path__ + "static/media/red_arrow.e4904151.webp";